module.exports = __webpack_public_path__ + "static/media/company-home-09.463f08cd.png";